
import { Link } from 'react-router-dom'
import { IconoHistorial } from '../assets/icons'

export default function CardChido({ titulo, boton, icon, enlace }) {

    return (
        <div
            className="card card-body mx-4 my-3 shadow-sm p-4 card-height"
            style={{
                maxWidth: '18rem',
                backgroundColor: 'white',
                height: enlace === '/autorizacion_salida' ? 240 : 200,
            }}
        >

            <ul className="d-grid gap-4 list-unstyled small">
                <li className="d-flex gap-4">
                    <div className="d-flex align-items-center gap-4">
                        {icon}
                        <h5>{titulo}</h5>
                    </div>
                </li>
            </ul>
            <div className='d-flex flex-column gap-3'>
                <Link to={enlace} className="btn btn-primary w-100">
                    {boton}
                </Link>
                {enlace === '/autorizacion_salida'
                    ? <Link to='/historial_salidas' className="btn btn-outline-primary">
                        <IconoHistorial /> Ver historial
                    </Link>
                    : ''}

                {enlace === '/comision'
                    ? <Link to='/historial_comisiones' className="btn btn-outline-primary">
                        <IconoHistorial /> Ver comisiones
                    </Link>
                    : ''}
            </div>

        </div>
    )
}

